import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type PatientsAction =
  | ActionType<typeof actions.fetchPatientsRequest>
  | ActionType<typeof actions.fetchPatientsSuccess>
  | ActionType<typeof actions.fetchPatientsFail>
  | ActionType<typeof actions.fetchPatientRequest>
  | ActionType<typeof actions.fetchPatientSuccess>
  | ActionType<typeof actions.fetchPatientFail>
  | ActionType<typeof actions.fetchPatientsEstimationsRequest>
  | ActionType<typeof actions.fetchPatientsEstimationsSuccess>
  | ActionType<typeof actions.fetchPatientsEstimationsFail>
  | ActionType<typeof actions.deleteUserRequest>
  | ActionType<typeof actions.deleteUserSuccess>
  | ActionType<typeof actions.deleteUserFail>
  | ActionType<typeof actions.resetUserPasswordRequest>
  | ActionType<typeof actions.resetUserPasswordSuccess>
  | ActionType<typeof actions.resetUserPasswordFail>

export interface PatientsState {
  isFetchingCreate: boolean
  data: any
  patientDetailData: {
    patient?: any
    estimations?: {
      content?: any
    }
  }
}

export enum PatientsActionTypes {
  FETCH_PATIENTS_REQUEST = '@@patients/FETCH_PATIENTS_REQUEST',
  FETCH_PATIENTS_SUCCESS = '@@patients/FETCH_PATIENTS_SUCCESS',
  FETCH_PATIENTS_FAIL = '@@patients/FETCH_PATIENTS_FAIL',
  FETCH_PATIENT_REQUEST = '@@patients/FETCH_PATIENT_REQUEST',
  FETCH_PATIENT_SUCCESS = '@@patients/FETCH_PATIENT_SUCCESS',
  FETCH_PATIENT_FAIL = '@@patients/FETCH_PATIENT_FAIL',
  FETCH_PATIENTS_ESTIMATIONS_REQUEST = '@@patients/FETCH_PATIENTS_ESTIMATIONS_REQUEST',
  FETCH_PATIENTS_ESTIMATIONS_SUCCESS = '@@patients/FETCH_PATIENTS_ESTIMATIONS_SUCCESS',
  FETCH_PATIENTS_ESTIMATIONS_FAIL = '@@patients/FETCH_PATIENTS_ESTIMATIONS_FAIL',
  DELETE_USER_REQUEST = '@@patients/DELETE_USER_REQUEST',
  DELETE_USER_SUCCESS = '@@patients/DELETE_USER_SUCCESS',
  DELETE_USER_FAIL = '@@patients/DELETE_USER_FAIL',
  RESET_USER_PASSWORD_REQUEST = '@@patients/RESET_USER_PASSWORD_REQUEST',
  RESET_USER_PASSWORD_SUCCESS = '@@patients/RESET_USER_PASSWORD_SUCCESS',
  RESET_USER_PASSWORD_FAIL = '@@patients/RESET_USER_PASSWORD_FAIL'
}
